import React, { useState } from "react";
import Logo from "../../assets/colibri-light.svg";

import HomeIcon from "../../assets/icons/home.svg";
import ProductIcon from "../../assets/icons/products.svg";
import SalesIcon from "../../assets/icons/sales.svg";
import ArrowWhiteIcon from "../../assets/icons/arrowWhite.svg";
import { IoLogOutOutline } from "react-icons/io5";
import { FiUsers, FiFileText } from "react-icons/fi";
import { NavLink, useNavigate } from "react-router-dom";
import { endAdminSession } from "../../utils/functions/auth";
import { userService } from "../../services/user.service";
import Alert from "../Alert/Alert";

import "./Sidebar.css";
const Sidebar = () => {
  const navigate = useNavigate();
  const [alert, setAlert] = useState(null);

  const closeSidebar = () => {
    document
      .querySelector(".container-sidebar")
      ?.classList.remove("show-sidebar");
  };

  const logout = async () => {
    try {
      await userService.signOut();
    } catch (error) {
      // igual cerramos la sesión local aunque falle el aviso al backend
    }

    endAdminSession();
    setAlert({ variant: "success", msg: "Sesión cerrada correctamente" });

    setTimeout(() => {
      navigate("/admin");
    }, 2000);
  };

  return (
    <div className="container-sidebar">
      <Alert alert={alert} />
      <button className="close-modal" onClick={() => closeSidebar()}>
        <img src={ArrowWhiteIcon} alt="" />
        <span>CERRAR</span>
      </button>
      <img className="logo" src={Logo} alt="" />
      <nav className="sidebar-menu">
        <NavLink
          to={"/admin/home"}
          className={({ isActive }) => `menu-item ${isActive ? "active" : ""}`}
        >
          <img src={ProductIcon} alt="" />
          <p>PRODUCTOS</p>
        </NavLink>
        <NavLink
          to={"/admin/categorias"}
          className={({ isActive }) => `menu-item ${isActive ? "active" : ""}`}
        >
          <img src={HomeIcon} alt="" />
          <p>CATEGORIAS</p>
        </NavLink>
        <NavLink
          to={"/admin/ventas"}
          className={({ isActive }) => `menu-item ${isActive ? "active" : ""}`}
        >
          <img src={SalesIcon} alt="" />
          <p>VENTAS</p>
        </NavLink>
        <NavLink
          to={"/admin/usuarios"}
          className={({ isActive }) => `menu-item ${isActive ? "active" : ""}`}
        >
          <FiUsers />
          <p>USUARIOS</p>
        </NavLink>
        <NavLink
          to={"/admin/contenido"}
          className={({ isActive }) => `menu-item ${isActive ? "active" : ""}`}
        >
          <FiFileText />
          <p>CONTENIDO</p>
        </NavLink>
      </nav>
      <button className="logout-item" onClick={logout}>
        <IoLogOutOutline />
        <p>CERRAR SESIÓN</p>
      </button>
    </div>
  );
};

export default Sidebar;
